import React from "react";

const Plan: React.FC = () => {
  return <div>Plan Content</div>;
};

export default Plan;
